import { render, staticRenderFns } from "./RequiredActionItem.vue?vue&type=template&id=174e209e&scoped=true&"
import script from "./RequiredActionItem.vue?vue&type=script&lang=js&"
export * from "./RequiredActionItem.vue?vue&type=script&lang=js&"
import style0 from "./RequiredActionItem.vue?vue&type=style&index=0&id=174e209e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174e209e",
  null
  
)

export default component.exports